import React from 'react'
import { Table, TableBody, TableCell, TableContainer,TableHead, TableRow, Paper, Box, Typography, Button, CircularProgress, Collapse, Alert, AlertTitle } from '@material-ui/core';
import './OrderTable.css';
import axios from "axios";
import {config} from "../../config/config";
import Cookies from "universal-cookie";
import { KeyboardArrowUp, KeyboardArrowDown, } from '@material-ui/icons';

const cookies = new Cookies();


function dateFormat(timestamp) {
  let objectDate = new Date(timestamp)
  let day = objectDate.getDate();
  let month = objectDate.getMonth();
  let year = objectDate.getFullYear();
  let hour = objectDate.getHours();
  let minute = objectDate.getMinutes();

  if (day < 10) {day = '0' + day;}
  if (month < 9) {month = `0${month+1}`;} else {month = `${month+1}`;}
  if (hour < 10) {hour = '0' + hour;}
  if (minute < 10) {minute = `0${minute}`;}

  let format1 = `${day}/${month}/${year-2000} ${hour}:${minute}`;
  return format1
}
      
    
const token = cookies.get("token");

// let dolar = config.DOLAR;

function capitalizeFirstLetter(string) {
  let cadena = String(string || '').trim().toLowerCase()
  if (!cadena) return '';
  return cadena.charAt(0).toUpperCase() + cadena.slice(1);
}


function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const orderId = row._id ? row._id : row.id;
  const unitCount = row.productList.reduce(
    (previousValue, currentValue) => Number(previousValue) + (Number(currentValue.qty) || 0),
    0,
  );

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <Button
            aria-label={`${open ? 'Ocultar' : 'Mostrar'} detalle del pedido ${orderId}`}
            size="small"
            onClick={() => setOpen(!open)}
            sx={{color:"inherit"}}
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </Button>
        </TableCell>
        <TableCell component="th" scope="row">{orderId}</TableCell>
        <TableCell component="th" scope="row">
          {dateFormat(row.timestamp)}
        </TableCell>
        <TableCell align="center">{unitCount}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Pedido {orderId} {row.presupuesto ? "(Presupuesto)" : ""}
              </Typography>
              <Table size="small" aria-label={`Productos del pedido ${orderId}`}>
                <TableHead>
                  <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell>Nombre</TableCell>
                    <TableCell align="right">Cant.</TableCell>
                    {/* <TableCell align="right">P.Unit ($)</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.productList.map((productListRow) => (
                    <TableRow key={productListRow._id ? productListRow._id : productListRow.id}>
                      <TableCell component="th" scope="row">
                        {productListRow.code}
                      </TableCell>
                      <TableCell>{capitalizeFirstLetter(`${
                        [productListRow.name,productListRow.color,productListRow.linea,productListRow.presentacion,`${productListRow.contenido ? (""+productListRow.contenido) : ""}`].filter(Boolean).join("|")
                        }`)}</TableCell>
                      <TableCell align="right">{productListRow.qty}</TableCell>
                      {/* <TableCell align="right">
                      {ccyFormat(productListRow.price ? productListRow.price : productListRow.usd*dolar)}
                      {itemClass.calcularPrecio(productListRow, dolar)}
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


export default function CollapsibleTable() {


  const [errorMessage, setErrorMessage] = React.useState('');
  // Backdrop or Loading spinner 
  const [order, setOrder] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [requestVersion, setRequestVersion] = React.useState(0);
 
  React.useEffect(() => {
    let cancel = false;
    setLoading(true)
    setErrorMessage('');
    if (cookies.get("user")) {
      const configuration = {
        method: "get",
        url: `${config.SERVER}/api/order/user`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      };
  
            // make the API call
        axios(configuration)
        .then((result) => {
          if (cancel) return;
          setOrder([...result.data])
          setLoading(false)
        })
        .catch(() => {
          setErrorMessage('No pudimos cargar tus pedidos. Revisá la conexión e intentá nuevamente.')
          setLoading(false)
        })
        return () => { 
          cancel = true;
        }
    } else {
      setLoading(false);
      setErrorMessage('La sesión no está disponible. Volvé a iniciar sesión para consultar tus pedidos.');
    }
  }, [requestVersion])
  
  
  return (
    <>
    	{loading ? (<>
				<Box sx={{ display: 'flex', mt:"30vh", height:"100%" }}>
					<CircularProgress aria-label="Cargando pedidos" />
				</Box>			
			</>) : errorMessage ? (
        <Alert
          severity="error"
          sx={{ width: '100%' }}
          action={<Button color="inherit" size="small" onClick={() => setRequestVersion(version => version + 1)}>Reintentar</Button>}
        >
          <AlertTitle>No pudimos mostrar los pedidos</AlertTitle>
          {errorMessage}
        </Alert>
      ) : order.length === 0 ? (
        <Box role="status" sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="h6">Todavía no enviaste pedidos</Typography>
          <Typography variant="body2" color="text.secondary">Cuando envíes uno, podrás consultar aquí su detalle.</Typography>
        </Box>
      ) : (<>
        <TableContainer component={Paper} sx={{ maxWidth: '100%' }}>
          <Table aria-label="Historial de pedidos">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>Pedido</TableCell>
                <TableCell>Fecha</TableCell>
                <TableCell align="center">Unidades</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {order.map((row) => (
                <Row key={row._id ? row._id : row.id} row={row} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
			</>)}
    
    </>


  );
}
